/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {isEmpty} from 'react-redux-firebase'
import {useHistory, Link} from 'react-router-dom'

import {SIZE} from 'baseui/spinner'
import {Block} from 'baseui/block'
import {Heading, HeadingLevel} from 'baseui/heading'
import {StyledLink} from 'baseui/link'
import {ParagraphSmall} from 'baseui/typography'

import CenteredBlock from '../../components/app/centered-block'
import LoadingSpinner from '../../components/app/loading-spinner'
import {setSelectedStudent} from '../persistence/user-slice'
import {routes} from '../../utils/config'
import StudentCard from './student-card'
import {Button, SHAPE} from 'baseui/button'
import {ArrowRight, ArrowLeft} from 'baseui/icon'
import {Footer} from '../../components/app'

const RoleSelector = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const {course} = useSelector(state => state.firestore?.data)
  const {enrollments} = useSelector(state => state.firestore?.ordered)
  //const [studentNames, setStudentNames] = useState(null)
  const [isReady, setIsReady] = useState(false)

  var focusedCard = 0

  const handleStudentClicked = (uid, event) => {
    console.log(`student clicked:`, uid)
    dispatch(setSelectedStudent({selectedStudent: uid}))
    history.push(routes.play.url)
  }

  const handleSelectorButtonClicked = scrollAmount => {
    var cardList = document.querySelectorAll('[id=studentCard]')
    const containerElm = document.getElementById('cardContainer')

    if (focusedCard + scrollAmount < cardList.length && focusedCard + scrollAmount >= 0) {
      focusedCard += scrollAmount
      const x =
        cardList[focusedCard].offsetLeft +
        cardList[focusedCard].clientWidth / 2 -
        containerElm.clientWidth / 2
      containerElm.scrollTo({
        left: x,
        behavior: 'smooth',
      })

      if (focusedCard === 0) {
        document.getElementById('paddleLeft').disabled = true
      } else {
        document.getElementById('paddleLeft').disabled = false
      }
      if (focusedCard === cardList.length - 1) {
        document.getElementById('paddleRight').disabled = true
      } else {
        document.getElementById('paddleRight').disabled = false
      }
    }
  }

  useEffect(() => {
    if (!isEmpty(enrollments)) {
      setTimeout(() => {
        //setStudentNames(enrollments.map(item => item.studentName))
        setIsReady(true)
        //button disabled by default workaround
        document.getElementById('paddleLeft').disabled = true
      }, 500)
    }
  }, [enrollments])

  return (
    <CenteredBlock
      overrides={{
        Block: {
          style: {float: 'left'},
        },
      }}
    >
      {!isReady ? (
        <LoadingSpinner $size={SIZE.large} />
      ) : (
        <>
          <HeadingLevel>
            <Heading>Who is Playing?</Heading>
          </HeadingLevel>
          <div>
            <Button
              id={'paddleLeft'}
              shape={SHAPE.round}
              overrides={{
                BaseButton: {
                  style: {
                    float: 'left',
                    position: 'relative',
                    top: '12.5rem',
                    right: '-1.875rem',
                    zIndex: '1',
                    paddingRight: '2px',
                    ':disabled': {
                      opacity: '0.2',
                    },
                  },
                },
              }}
              onClick={() => handleSelectorButtonClicked(-1)}
              startEnhancer={() => <ArrowLeft size={35} />}
            ></Button>
            <Block
              id={'cardContainer'}
              overrides={{
                Block: {
                  style: ({$theme}) => ({
                    display: 'block',
                    position: 'relative',
                    zIndex: '-0.5',
                    backgroundColor: 'rgba(242, 238, 233, 0.5)',
                    width: '41.25rem', //660px
                    height: '475px',
                    padding: '20px',
                    borderRadius: '25px',
                    flexDirection: 'row',
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                    whiteSpace: 'nowrap',
                    justifyContent: 'center',
                    alignItems: 'stretch',
                    boxSizing: 'border-box',
                    textAlign: 'center',
                    float: 'left',
                    scrollBehavior: 'smooth',
                  }),
                },
              }}
            >
              {enrollments.map(student => {
                console.log(`student:`, student)
                return (
                  <StudentCard
                    key={student.id}
                    name={student.studentName}
                    uid={student.id}
                    data={student.data}
                    course={course}
                    onClick={handleStudentClicked}
                  />
                )
              })}
              <Block
                overrides={{
                  Block: {
                    style: {
                      margin: '-0.5rem auto',
                      position: 'fixed',
                      left: '0',
                      right: '0',
                    },
                  },
                }}
              >
                <ParagraphSmall>
                  Want to add another player?{' '}
                  <StyledLink
                    href={'https://secretofthesourcecode.com/registration/'}
                    target="_blank"
                  >
                    Click here!
                  </StyledLink>
                </ParagraphSmall>
              </Block>
            </Block>
            <Button
              id={'paddleRight'}
              shape={SHAPE.round}
              overrides={{
                BaseButton: {
                  style: {
                    float: 'right',
                    position: 'relative',
                    top: '12.5rem', //200px
                    right: '1.875rem',
                    zIndex: '1',
                    paddingRight: '2px',
                    ':disabled': {
                      opacity: '0.2',
                    },
                  },
                },
              }}
              startEnhancer={() => <ArrowRight size={35} />}
              onClick={() => handleSelectorButtonClicked(1)}
            ></Button>
          </div>
        </>
      )}
    </CenteredBlock>
  )
}

export default RoleSelector
